module.exports = __webpack_public_path__ + "img/wizard-04.fa35fb48.png";